import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { selectIsModalLanguagesEnabled, selectLanguage } from '../../../redux/main/main.selectors';
import { toggleModalLanguages, setLanguage } from '../../../redux/main/main.actions';


import Modal from '../Modal/Modal';

import './ModalLanguages.scss';

export const ModalLanguages = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const isOpen = useSelector(selectIsModalLanguagesEnabled);
    const initialLang = i18n.language;

    // const lang = useSelector(selectLanguage);
    // const [selectedLang, setSelectedLang] = useState('');
    const [selectedLang, setSelectedLang] = useState(initialLang);

    // useEffect(() => {
    //     if (!lang) return;
    //     setSelectedLang(lang);
    //     return () => { };
    // }, [lang]);

    const handleCancel = () => {
        dispatch(toggleModalLanguages());
        setTimeout(() => {
            // setSelectedLang(lang);
            setSelectedLang(initialLang);
        }, 300);
    };

    // const isValidLangCode = (langCode = '') => {
    //     return ['en', 'fr'].includes(langCode);
    // }

    const handleConfirm = () => {
        if (selectedLang) {
            setTimeout(() => {
                i18n.changeLanguage(selectedLang);
                // dispatch(setLanguage(selectedLang));
                dispatch(toggleModalLanguages());
            }, 50);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-languages`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{`Let's build something new`}</div>
            <div className="modal-content-body">

                <div className='section-group'>
                    <div className='section-group-item'>
                        <div className='section-group-item-title'>{t('m_languages.title')}</div>

                        <div className="section-group-item-title second">{t('m_languages.subtitle')}</div>

                        <div className='left-group right'>
                            <div className='right-group'>
                                <div className={`left-group-item import wrap ${selectedLang === 'en' ? 'selected' : ''}`} onClick={() => setSelectedLang('en')}>
                                    <div className='lg-origin'>English</div>
                                    <div className='lg-eng'>English</div>
                                    <div className='lg-code'>en</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'fr' ? 'selected' : ''}`} onClick={() => setSelectedLang('fr')}>
                                    <div className='lg-origin'>Français</div>
                                    <div className='lg-eng'>French</div>
                                    <div className='lg-code'>fr</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'de' ? 'selected' : ''}`} onClick={() => setSelectedLang('de')}>
                                    <div className='lg-origin'>Deutsch</div>
                                    <div className='lg-eng'>German</div>
                                    <div className='lg-code'>de</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'hi' ? 'selected' : ''}`} onClick={() => setSelectedLang('hi')}>
                                    <div className='lg-origin bottom-4px'>हिंदी</div>
                                    <div className='lg-eng'>Hindi</div>
                                    <div className='lg-code'>hi</div>
                                </div>
                            </div>
                            <div className='right-group'>
                                <div className={`left-group-item import wrap ${selectedLang === 'id' ? 'selected' : ''}`} onClick={() => setSelectedLang('id')}>
                                    <div className='lg-origin'>Bahasa Indonesia</div>
                                    <div className='lg-eng'>Indonesian</div>
                                    <div className='lg-code'>id</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'it' ? 'selected' : ''}`} onClick={() => setSelectedLang('it')}>
                                    <div className='lg-origin'>Italiano</div>
                                    <div className='lg-eng'>Italian</div>
                                    <div className='lg-code'>it</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'ja' ? 'selected' : ''}`} onClick={() => setSelectedLang('ja')}>
                                    <div className='lg-origin top-3px'>日本語</div>
                                    <div className='lg-eng'>Japanese</div>
                                    <div className='lg-code'>ja</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'ko' ? 'selected' : ''}`} onClick={() => setSelectedLang('ko')}>
                                    <div className='lg-origin top-3px'>한국어</div>
                                    <div className='lg-eng'>Korean</div>
                                    <div className='lg-code'>ko</div>
                                </div>
                            </div>
                            <div className='right-group'>
                                <div className={`left-group-item import wrap ${selectedLang === 'pl' ? 'selected' : ''}`} onClick={() => setSelectedLang('pl')}>
                                    <div className='lg-origin'>Polski</div>
                                    <div className='lg-eng'>Polish</div>
                                    <div className='lg-code'>pl</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'pt_BR' ? 'selected' : ''}`} onClick={() => setSelectedLang('pt_BR')}>
                                    <div className='lg-origin'>Português</div>
                                    <div className='lg-eng'>Portuguese</div>
                                    <div className='lg-code'>pt-BR</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'zh_CN' ? 'selected' : ''}`} onClick={() => setSelectedLang('zh_CN')}>
                                    <div className='lg-origin top-4px'>简体中文</div>
                                    <div className='lg-eng'>Simplified Chinese</div>
                                    <div className='lg-code'>zh-CN</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'es' ? 'selected' : ''}`} onClick={() => setSelectedLang('es')}>
                                    <div className='lg-origin'>Español</div>
                                    <div className='lg-eng'>Spanish</div>
                                    <div className='lg-code'>es</div>
                                </div>
                            </div>
                            <div className='right-group'>
                                <div className={`left-group-item import wrap ${selectedLang === 'th' ? 'selected' : ''}`} onClick={() => setSelectedLang('th')}>
                                    <div className='lg-origin top-3px'>ภาษาไทย</div>
                                    <div className='lg-eng'>Thai</div>
                                    <div className='lg-code'>th</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'zh_TW' ? 'selected' : ''}`} onClick={() => setSelectedLang('zh_TW')}>
                                    <div className='lg-origin top-4px'>繁體中文</div>
                                    <div className='lg-eng'>Traditional Chinese</div>
                                    <div className='lg-code'>zh-TW</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'tr' ? 'selected' : ''}`} onClick={() => setSelectedLang('tr')}>
                                    <div className='lg-origin'>Türkçe</div>
                                    <div className='lg-eng'>Turkish</div>
                                    <div className='lg-code'>tr</div>
                                </div>
                                <div className={`left-group-item import wrap ${selectedLang === 'vi' ? 'selected' : ''}`} onClick={() => setSelectedLang('vi')}>
                                    <div className='lg-origin'>Tiếng Việt</div>
                                    <div className='lg-eng'>Vietnamese</div>
                                    <div className='lg-code'>vi</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='buttons-section'>
                    <button className='button-second' onClick={() => handleCancel()}>{t('b.cancel')}</button>
                    <button onClick={() => handleConfirm()}>{t('b.confirm')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalLanguages;
